import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'slate-react';
import classNames from 'classnames';
import makeResizable from './makeResizable';
import MediaToolbar from '../../LightboxPlugin/components/Toolbar';
import MediaStates from '../../../components/MediaStates';
import './style.css';

function getNodeWidth(node) {
  return node.data.get('width', 'auto');
}

function getNodeHeight(node) {
  return node.data.get('height', 'auto');
}

function isDataURI(url) {
  return url.startsWith('data:image/');
}

var Image =
/*#__PURE__*/
function (_Component) {
  _inherits(Image, _Component);

  function Image() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Image);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Image)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "toggleLightbox", function () {
      _this.props.editor.command('openLightbox', _this.props.node);
    });

    _defineProperty(_assertThisInitialized(_this), "onDoubleClick", function () {
      if (_this.props.enableLightbox) {
        _this.toggleLightbox();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderStates", function (_ref) {
      var loading = _ref.loading,
          error = _ref.error;
      var _this$props = _this.props,
          node = _this$props.node,
          isFocused = _this$props.isFocused,
          editor = _this$props.editor,
          enableLightbox = _this$props.enableLightbox;
      var width = getNodeWidth(node);
      var height = getNodeHeight(node);
      var url = node.data.get('url');
      return React.createElement(MediaStates, {
        isFocused: isFocused,
        loading: loading,
        mediaType: 'image',
        error: error,
        wrapperStyle: {
          minHeight: 124,
          minWidth: error ? 384 : 300,
          maxHeight: error ? 124 : null,
          width: width,
          height: height
        },
        wrapperClassNames: 'image-block line-height-larger width-full height-full'
      }, React.createElement(MediaToolbar, {
        blockKey: node.key,
        url: url,
        toggleLightbox: _this.toggleLightbox,
        readOnly: _this.props.editor.readOnly,
        enableLightbox: enableLightbox,
        onDownload: _this.props.onDownload,
        onRemove: function onRemove() {
          editor.removeNodeByKey(node.key);
        },
        error: error
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveImage", function () {
      var _this$props2 = _this.props,
          node = _this$props2.node,
          editor = _this$props2.editor;
      editor.removeImage(node);
    });

    return _this;
  }

  _createClass(Image, [{
    key: "render",
    value: function render() {
      if (!this.props.node) {
        return false;
      }

      var _this$props3 = this.props,
          node = _this$props3.node,
          enableLightbox = _this$props3.enableLightbox,
          style = _this$props3.style,
          isSelected = _this$props3.isSelected,
          isFocused = _this$props3.isFocused,
          attributes = _this$props3.attributes,
          resizableAttributes = _this$props3.resizableAttributes;
      var url = node.data.get('url');
      var width = getNodeWidth(node);
      var imageStyle = style || {
        width: width
      };
      var loading = node.data.get('loading');
      var error = node.data.get('error');
      var displayImage = !loading && (!error || isDataURI(url));
      return displayImage ? React.createElement("div", Object.assign({}, resizableAttributes, attributes, {
        style: imageStyle,
        className: classNames('image-block inline-block radius-normal', {
          'is-focused': isFocused || isSelected
        })
      }), React.createElement("div", {
        style: {
          width: 'inherit',
          height: 'inherit',
          maxWidth: '100%'
        },
        className: "inline-block position-relative radius-normal overflow-hidden"
      }, React.createElement("img", {
        src: url,
        onDoubleClick: this.onDoubleClick,
        draggable: !this.props.editor.readOnly,
        alt: url,
        style: {
          width: 'inherit',
          height: 'inherit'
        },
        className: "image-block-img"
      }), React.createElement(MediaToolbar, {
        blockKey: node.key,
        url: url,
        toggleLightbox: this.toggleLightbox,
        readOnly: this.props.editor.readOnly,
        enableLightbox: enableLightbox,
        onDownload: this.props.onDownload,
        onRemove: this.onRemoveImage
      }))) : this.renderStates({
        loading: loading,
        error: error
      });
    }
  }]);

  return Image;
}(Component);

_defineProperty(Image, "propTypes", {
  enableLightbox: PropTypes.bool,
  node: PropTypes.object,
  editor: PropTypes.instanceOf(Editor),
  parent: PropTypes.object,
  getUser: PropTypes.func,
  style: PropTypes.object,
  onDownload: PropTypes.func,
  onResize: PropTypes.func,
  isSelected: PropTypes.bool,
  isFocused: PropTypes.bool,
  attributes: PropTypes.object,
  resizableAttributes: PropTypes.object,
  iframelyApiKey: PropTypes.string
});

export default makeResizable({
  getNodeWidth: getNodeWidth
})(Image);